﻿import React, { useEffect } from 'react';
import { Replicate } from '../../models/AnalyticalPlans/replicate'; 
import { LookupItem } from '../../models/lookup-item';

const SVG_NS = "http://www.w3.org/2000/svg";

export interface Props {
    replicate: Replicate;
    containerId: string;
    sampleTypes?: LookupItem[];
}

export default function ReplicatesVisualizerComponent(props: Props) {

    console.log("props.replicate");
    console.log(props.replicate);



    useEffect(() => {
        createDiagram();
    }, [props.replicate, props.sampleTypes]);

    return (
        <div id={`svg-container-${props.containerId}`}>
            <svg id={`svg-cont-${props.containerId}`} height="500" width="800" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet"></svg>
        </div>
    );

    function createDiagram() {

        console.log("INIT: props.sampleTypes:")
        console.log(props.sampleTypes)

        if (!props.sampleTypes || !props.replicate || !props.replicate.samplesString || !props.replicate.injections || !props.replicate.preparations) 
            return;

        let sampleTypesString = props.replicate.samplesString; 

        let injections = props.replicate.injections;
        let vials = props.replicate.preparations;

        let sampleTypes: string[] = [];

        //alter the font size and x position based on sample name length (e.g. "E" vs "PRS")

        let threeLetterSamples = props.sampleTypes.filter(s => s.name.length === 3);
        let twoLetterSamples = props.sampleTypes.filter(s => s.name.length === 2);
        let singleLetterSamples = props.sampleTypes.filter(s => s.name.length === 1);
        
        threeLetterSamples.forEach(tls => {
            if (sampleTypesString.includes(tls.name)) {
                sampleTypes.push(tls.name);
                sampleTypesString = sampleTypesString.replace(tls.name, '');
            }
        });

        twoLetterSamples.forEach(tls => {
            if (sampleTypesString.includes(tls.name)) {
                sampleTypes.push(tls.name);
                sampleTypesString = sampleTypesString.replace(tls.name, '');
            }
        });

        singleLetterSamples.forEach(sls => {
            if (sampleTypesString.includes(sls.name)) {
                sampleTypes.push(sls.name);
                sampleTypesString = sampleTypesString.replace(sls.name, '');
            }
        });

        let cont = document.getElementById(`svg-cont-${props.containerId}`);

        cont.innerHTML = '';

        let fillColors = ["lightBlue", "lightGreen", "pink", "gray"];
        let colors = ["blue", "green", "red", "black"];
        let multiplier = 80;
        let fontSize = (multiplier / 100) * 1.3;

        let qty = 0;
        let cr = 0;
        let textX = 0.41 * multiplier;
        if (injections < 2)
            textX = 0.48 * multiplier;

        for (let r = 0; r < vials; r++) {
            for (let inj = 0; inj < injections; inj++) {

                sampleTypes.forEach((st, idx) => {

                    let localFontSize = fontSize - (st.length * 1.5);
                    let xOffset = (st.length * 3);

                    let c1 = createSvgElement("circle");

                    c1.setAttribute("cx", ((0.6 * multiplier) + (cr * multiplier)).toString());
                    c1.setAttribute("cy", ((0.8 * multiplier) + ((idx) * multiplier)).toString());
                    c1.setAttribute("r", (0.4 * multiplier).toString());
                    c1.setAttribute("stroke", colors[idx]);
                    c1.setAttribute("stroke-width", "2");
                    c1.setAttribute("fill", fillColors[idx]);
                    cont.appendChild(c1);
                    qty++;

                    let t1 = createSvgElement("text");
                    t1.setAttribute("x", (textX + (cr * multiplier) - xOffset).toString());
                    t1.setAttribute("y", ((0.87 * multiplier) + (idx * multiplier)).toString());
                    t1.setAttribute("fill", colors[idx]);
                    t1.setAttribute("style", `font-family:Arial; font-size:${localFontSize}rem`);

                    if (injections < 2)
                        t1.textContent = `${st}${r + 1}`;
                    else
                        t1.textContent = `${st}${r + 1}-${inj + 1}`;

                    cont.appendChild(t1);
                });
                cr++;
            }
        }

        cont.setAttribute("width", ((vials * injections * multiplier) + 50).toString());
        cont.setAttribute("height", ((sampleTypes.length * multiplier) + 50).toString());
    }

    function createSvgElement(e: any) {
        return document.createElementNS(SVG_NS, e);
    }

}